import isMeetingOnCalendarSharedWithMe from './isMeetingOnCalendarSharedWithMe';
import { CalendarEvent } from 'owa-calendar-types';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns true if the HideAttendees property can be set on this event
 * @param event Calendar event
 */
export default function canSetHideAttendees(event: CalendarEvent): boolean {
    if (!isFeatureEnabled('cal-mf-hideAttendeeList')) {
        return false;
    }

    if (isMeetingOnCalendarSharedWithMe(event)) {
        // If it's a shared calendar, only allow if the flight is on
        return isFeatureEnabled('cal-mf-enableHideAttendeeListOnSharedCalendar');
    }

    return true;
}
